import React, { useContext, useState } from "react";
import { TicketProps } from "../../FlightPackage/Ticket/FlightLegs/ticketFlightLegs";
import { TicketLineItem } from "../../sharedCode/avroGraphql";
import { GlobalContext } from "../../Utils/Contexts";
import DeleteConfirmationDialog from "../DeleteConfirmationDialog";
import { TicketLineItemExtended } from "../../Utils/TypeExtensions";
import FuelRow from "./fuelRow";
import { isFuelLineItem } from "../validation/newHelpers";
import { saveTicketChanges } from "../../Utils/TicketDatabase";

interface State {
    ShowDeleteConfirmation: boolean;
    IdToDelete: number;
}

export default function FuelDetails(props: TicketProps): JSX.Element {
    const context = useContext(GlobalContext);

    const [localState, setLocalState] = useState<State>({
        ShowDeleteConfirmation: false,
        IdToDelete: 0,
    });

    return (
        <>
            {localState.ShowDeleteConfirmation && <DeleteConfirmationDialog entityName={"FUEL"} onClose={handleDeleteCanceled} onConfirm={handleDeleteConfirmed} />}
            {(props.ticket.LineItems?.filter((r) => isFuelLineItem(r)) ?? []).map((lineItem) => (
                <FuelRow
                    key={`row${lineItem?.id}-${props.ticket.LineItems?.length}`}
                    lineItem={lineItem as TicketLineItem}
                    handleDelete={handleDelete}
                    mergeRowChanges={mergeRowChanges}
                    {...props}
                />
            ))}
        </>
    );

    function handleDelete(lineItemToDelete: TicketLineItem): void {
        setLocalState((prev) => {
            return { ...prev, ShowDeleteConfirmation: true, IdToDelete: lineItemToDelete.id };
        });
    }

    function handleDeleteCanceled(): void {
        setLocalState((prev) => {
            return { ...prev, ShowDeleteConfirmation: false, IdToDelete: 0 };
        });
    }

    function handleDeleteConfirmed(): void {
        if (!props.ticket.LineItems) return;
        const lineItemToDelete = props.ticket.LineItems.find((p) => p?.id === localState.IdToDelete);
        if (lineItemToDelete) {
            const indexToDelete = props.ticket.LineItems.indexOf(lineItemToDelete);
            if (indexToDelete > -1) {
                const newList = [...props.ticket.LineItems.slice(0, indexToDelete), ...props.ticket.LineItems.slice(indexToDelete + 1)];
                saveTicketChanges(props.ticket.id, { LineItems: newList }).catch(() => props.showForceReloadDialogue());
            }
        }
    }

    function mergeRowChanges(locationId: number, changes: Record<string, unknown>) {
        const lineItems = props.ticket?.LineItems?.map((lineItem) => {
            if (lineItem?.id === locationId) {
                return { ...lineItem, ...changes } as TicketLineItemExtended;
            } else {
                return lineItem;
            }
        });

        saveTicketChanges(props.ticket.id, { LineItems: lineItems }).catch(() => props.showForceReloadDialogue());
    }
}
